export const WorksObject =
     [
    {
        id: 1,
        name: "CuroRx",
        img: require("./images/curorx.png"),
        gitHub: "https://github.com/NextEhealth/curo-v2",
        live: "https://curorx.life/",
        about:  {
            Images:[require("./images/curorx.png"), require("./images/pharmacy.png"), require("./images/Provider.png"), require("./images/screencapture-curo-v2-beta-azurewebsites-net-patient-homepage-2023-10-30-20_47_16.png")],
            Text: "CuroRx is a web application is a pharmacy, provider and patient point of communications serving the needs of patients and providers to help a pharmacy business operate more efficiently. It is currently I am part of the developing team in NextEHealth.",
            Tech: ["NodeJS","ExpressJS", "ReactJS", "MySQL",  "Firebase", "Azure Web Apps", "Bootstrap", "Material UI", "Google APIs", "Google Maps API", "Mailgun", "Twilio", "Axios", "socket.io", "JWT", "Azure Storage"  ]
        }
    },{
        id: 6,
        name: "Movie Night",
        img: require("./images/movie-night1.png"),
        gitHub: "https://github.com/bavely/Movie-Night-AI",
        live: "https://movie-night.pavli-tawfik.com/",
        about:  {
            Images:[require("./images/movie-night1.png"), require("./images/movie-night2.png"), require("./images/movie-night3.png"), require("./images/movie-night4.png"), require("./images/movie-night5.png"), require("./images/movie-night6.png"), require("./images/movie-night7.png"), require("./images/movie-night8.png")],
            Text: "Movie Night is your go-to web app for finding the perfect flick! Whether you’re in the mood to search by keywords or browse by genre, we’ve got you covered. Not sure what to watch? Just ask our AI assistant for spot-on movie recommendations. Grab the popcorn and let the binge-watching begin!",
            Tech: ["OpenAI", "TMDB API","Watchmode API" ,"Angular 18", "RxJS" ,"Tailwind", "CSS", "PrimeNg UISuite", "Ubuntu Linux VPS",  "Nginx web server" ]
        }
    },
    {
        id: 2,
        name: "Pawinpaw",
        img: require("./images/register.JPG"),
        gitHub: "https://github.com/khwilson27/pawinpaw",
        live: "http://pawinpaw.pavli-tawfik.com/",
        about:  {
            Images:[require("./images/nearby.JPG"), require("./images/register.JPG"), require("./images/profile.JPG"), require("./images/nearby2.JPG"), require("./images/match.JPG")],
            Text: "Pawinpaw is a web application that allows users to search for and connect with other pet owners. It is a practicing application I am part of the developing team during UCI Bootcamp.",
            Tech: ["NodeJS","ExpressJS", "ReactJS", "MySQL", "sequelize", 'heroku' ,"Bootstrap", "Material UI", "Google APIs", "Google Maps API",  "Axios", "socket.io", "JWT"  ]
        }
    },
    {
        id: 3,
        name: "React Messenger",
        img: require("./images/Login.png"),
        gitHub: "https://github.com/bavely/React-Messenger",
        live: "/pagenotfound",
        about: {
            Images:[ require("./images/Login.png"), require("./images/chathistory.png"), require("./images/chat.png"), require("./images/profile.png")],
            Text: "React messenger is a place holder name of a messaging application I am developing as a private project. It is still under planning and development. The messenger will allow users with the same interests to communicate , chat and create groups under different topics.",
            Tech: ["NodeJS","ExpressJS", "React Native", "MongoDB","Mongoose","Bootstrap", "Google APIs", "Google Maps API", "Mailgun", "Twilio", "Axios", "socket.io", "JWT"  ]
        }
    },
    {
        id: 4,
        name: "Tasty",
        img: require("./images/Tasty1.png"),
        gitHub: "https://github.com/bavely/tasty",
        live: "https://tasty.pavli-tawfik.com",
        about: {
            Images:[ require("./images/Tasty1.png"), require("./images/tasty2.png"), require("./images/tasts3.png"), require("./images/tasty4.png")],
            Text: "Tasty is a web application that allows users to search delicious recipes. It is a practicing application of Typescript I am developing as a private project.",
            Tech: ["ReactJS", "Typescript", "CSS", "REST API"  ]
        }
    },
    {
        id: 5,
        name: "TODO AI",
        img: require("./images/todo.png"),
        gitHub: "https://github.com/bavely/Smart_AI_ToDo-",
        live: "https://smart-ai-to-do.vercel.app/",
        about: {
            Images:[require("./images/todo.png")],
            Text: "TODO AI is a task managment web application that allows users to manage their tasks using AI chatbot. It is a practicing application of Typescript and NextJS I built as a private project to practice NextJS, Typescript and AI implementations.",
            Tech: [ "Typescript", "ChatGPT API, CopilotKit", "NextJS", "MongoDB", "GraphQL" ,"CSS"  ]   

    },

    },
    {
        id: 7, //id 6 is already taken above
        name: "RIVER'S EDGE PHARMACY Website",
        img: require("./images/re1.png"),
        gitHub: "#",
        live: "https://www.repharmacy.com/",
        about: {
            Images:[require("./images/re1.png"), require("./images/re2.png"), require("./images/re3.png"), require("./images/re4.png")],
            Text: "RIVER'S EDGE PHARMACY is a website for RIVER'S EDGE PHARMACY. RIVER'S EDGE PHARMACY is specialty pharmacy located in Irvine, California. I was a part of the developing, hosting and maintaining team for this website.",
            Tech: [ "Wordpress", "Elementor", "CSS", "HTML", "Javascript", "PHP", "yoast seo", "Google Analytics", "Azure Web Apps"  ]
        }
    },
    {
        id: 8,
        name: "AMERICAN COURIER SERVICES Website",
        img: require("./images/ac1.png"),
        gitHub: "#",
        live: "https://american-courier.com/",
        about: {
            Images:[require("./images/ac1.png"), require("./images/ac2.png"), require("./images/ac3.png"), require("./images/ac4.png")],
            Text: "AMERICAN COURIER SERVICES is a courier services website located in Los Angeles, California. I was a part of the developing, hosting and maintaining team for this website.",
            Tech: [ "Wordpress", "Elementor", "CSS", "HTML", "Javascript", "PHP", "yoast seo", "Google Analytics", "Digital Ocean VPS"  ]
        }
    },
    {
        id: 9,
        name:"WIZEAS Website",
        img: require("./images/w.png"),
        gitHub: "#",
        live: "https://wizeas.com/",
        about: {
            Images:[require("./images/w.png"), require("./images/w2.png"), require("./images/w3.png"), require("./images/w4.png"), require("./images/w5.png"), require("./images/w6.png"), require("./images/w7.png"), require("./images/w8.png")],
            Text: "WIZEAS is a website for WIZEAS. WIZEAS is a web development company located in Austin, Texas. I developed, hosted and maintained this website.",
            Tech: [ "ReactJS", "Tailwind CSS", "Shadcn UI", "CSS", "HTML", "Javascript", "NodeJS", "ExpressJS"  ]
        }
    }
    
    
    ]
    
